import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import paginationStyle from '../../assets/jss/material-kit-react/components/paginationStyle';
function Pagination({ ...props }) {
    const { classes, pages, color } = props;
    return (React.createElement("ul", { className: classes.pagination }, pages.map((prop, key) => {
        const paginationLink = classNames({
            [classes.paginationLink]: true,
            [classes[color]]: prop.active,
            [classes.disabled]: prop.disabled,
        });
        return (React.createElement("li", { className: classes.paginationItem, key: key }, prop.onClick !== undefined ? (React.createElement(Button, { onClick: prop.onClick, className: paginationLink }, prop.text)) : (React.createElement(Button, { className: paginationLink }, prop.text))));
    })));
}
Pagination.defaultProps = {
    color: 'primary',
};
Pagination.propTypes = {
    classes: PropTypes.object.isRequired,
    pages: PropTypes.arrayOf(PropTypes.shape({
        active: PropTypes.bool,
        disabled: PropTypes.bool,
        text: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.oneOf(['PREV', 'NEXT', '...']),
        ]).isRequired,
        onClick: PropTypes.func,
    })).isRequired,
    color: PropTypes.oneOf(['primary', 'info', 'success', 'warning', 'danger']),
};
export default withStyles(paginationStyle)(Pagination);
//# sourceMappingURL=Pagination.js.map